import React from 'react';
import type { MessageSequenceStep } from '@/types/messageSequence';
import { Clock } from 'lucide-react';

interface Props {
	step: MessageSequenceStep;
	index: number;
	formatStepTime: (step: MessageSequenceStep) => string;
	isLast?: boolean;
}

const SequenceStepPreview: React.FC<Props> = ({
	step,
	index,
	formatStepTime,
}) => {
	return (
		<li>
			<div className="rounded-xl border shadow-sm bg-background p-3">
				<div className="grid gap-2">
					<div className="text-xs rounded-full py-0.5 text-muted-foreground shrink-0 w-fit">
						Message {index + 1}
					</div>
					<div className="flex items-start justify-between gap-2">
						<p className="text-sm font-medium text-foreground line-clamp-2">
							{step.text}
						</p>
					</div>
					<div className="flex flex-wrap items-center gap-2 rounded-full bg-muted px-3 py-1.5 text-sm">
						<Clock className="h-4 w-4" />
						{index === 0 && step.sendImmediately ? (
							<span>
								Send{' '}
								<span className="font-medium">immediately</span>{' '}
								after adding to sequence
							</span>
						) : (
							<>
								<span>
									{index === 0 ? 'Send' : 'Then send'}
								</span>
								<span className="font-medium">
									{step.delayDays}
								</span>
								<span>
									day{step.delayDays === 1 ? '' : 's'} after{' '}
									{index === 0
										? 'adding to sequence'
										: 'the last message'}{' '}
									at
								</span>
								<span className="font-medium">
									{formatStepTime(step)}
								</span>
							</>
						)}
					</div>
				</div>
			</div>
		</li>
	);
};

export default SequenceStepPreview;
